import { useTranslation } from 'react-i18next';
import { Navigate, useParams } from 'react-router-dom';

import { ExportedPhysicalContactDetails } from 'src/Components/Contacts/ExportedPhysicalContactDetails';
import { AnimatedRoutedDrawer } from 'src/Components/Drawers/AnimatedRoutedDrawer';

type ExportedContactParams = {
  contactId: string;
  token: string;
};

const ViewExportedContactDrawer = () => {
  const { t } = useTranslation();
  const { contactId, token } = useParams<ExportedContactParams>();

  if (!contactId) {
    return <Navigate to="/" replace />;
  }

  return (
    <AnimatedRoutedDrawer title={t('contactDrawer.title', 'Fiche contact')}>
      {() => <ExportedPhysicalContactDetails contactId={contactId} token={token ?? ''} />}
    </AnimatedRoutedDrawer>
  );
};

export default ViewExportedContactDrawer;
